<template functional>
  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" :width="props.size" :height="props.size" viewBox="0 0 12 12">
    <g transform="translate(8781.912 14270.912)">
      <g transform="translate(-8781.006 -14270.006)">
        <path d="M14.943,5.25,5.25,14.943" transform="translate(-5.25 -5.25)" fill="none" :stroke="props.colorFill" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" :style="{ fill: 'none !important' }" />
        <path d="M14.943,14.943,5.25,5.25" transform="translate(-5.25 -5.25)" fill="none" :stroke="props.colorFill" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" :style="{ fill: 'none !important' }" />
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'IconXmark',

  props: {
    size: { type: [String, Number], default: '16px' },
    colorFill: { type: String, default: '#4480ae' },
  }
}
</script>